import { EVENT_TYPE } from '@/common/resources/const'
export const VIEW_MORE = 'viewmore'

// element types
export const ELEMENT_TYPE_CONTAINER = 'container'
export const ELEMENT_TYPE_VIEW_MORE = 'viewmore'
export const ELEMENT_TYPE_TITLE = 'title'
export const ELEMENT_TYPE_CATEGORY = 'category'

// action types
export const ACTION_TYPE_CLICK = 'click'
export const ACTION_TYPE_DISPLAY = 'display'

// execute types
export const EXECUTE_TYPE_FETCH = 'fetch'
export const EXECUTE_TYPE_VIEW_MORE = 'viewmore'
export const EXECUTE_TYPE_LANDING = 'landing'
export const EXECUTE_TYPE_TOGGLE = 'toggle'
export const EXECUTE_TYPE_PLAY = 'play'

// event list for mapping (former version)
export const EVENT_LIST = [
  EVENT_TYPE.ON_DISPLAY,
  EVENT_TYPE.ON_CONTENT,
  EVENT_TYPE.ON_VIEW_MORE,
  EVENT_TYPE.ON_NAVIGATION,
  EVENT_TYPE.ON_CLICK,
  EVENT_TYPE.ON_DETAIL,
]

// multi section event list for mapping
export const MULTI_SECTION_EVENT_LIST = [
  EVENT_TYPE.ON_DISPLAY,
  EVENT_TYPE.ON_CONTENT,
  EVENT_TYPE.ON_VIEW_MORE,
]

// cell event list for mapping
export const CELL_EVENT_LIST = [
  EVENT_TYPE.ON_NAVIGATION,
  EVENT_TYPE.ON_CLICK,
  EVENT_TYPE.ON_DETAIL,
  EVENT_TYPE.ON_INSTANT_PLAY,
  EVENT_TYPE.ON_ZZIM,
  EVENT_TYPE.OFF_ZZIM,
]
